import { render, staticRenderFns } from "./SmartDialog.vue?vue&type=template&id=1b5bd0c2&lang=pug"
import script from "./SmartDialog.vue?vue&type=script&lang=js"
export * from "./SmartDialog.vue?vue&type=script&lang=js"
import style0 from "./SmartDialog.vue?vue&type=style&index=0&id=1b5bd0c2&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports